import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SearchInput } from '@/components/common/SearchInput';
import { TableColumnVisibilityMenu } from '@/components/common/TableColumnVisibilityMenu';
import { TableGroupMenu } from '@/components/common/TableGroupMenu';
import { TableSortMenu } from '@/components/common/TableSortMenu';
import IndicatorHeader from '@/components/indicators/IndicatorHeader';
import CollecteFilterDrawer from '@/components/indicators/collecte/CollecteFilterDrawer';
import { columnsDefManageYear, defaultColumnVisibilityManageYear } from '@/components/indicators/index/IndicatorData';
import ManageCollecteTablePerYear from '@/components/indicators/manage-collecte/ManageCollecteTablePerYear';

const collecteSearchSchema = z.object({
  type: z.enum(['perYear', 'perIndicator']).default('perYear'),
  year: z.string().catch(''),
  page: z.number().catch(1),
  pageSize: z.number().catch(25),
  filter: z.string().catch(''),
  sort: z.string().catch(''),
  group_by: z.string().catch(''),
  search: z.string().catch(''),
  columns: z.string().catch(''),
});

export const Route = createFileRoute('/_layout/$slug/indicators/collecte/$year/manage')({
  component: RouteComponent,
  validateSearch: (search) => collecteSearchSchema.parse(search),
});

function RouteComponent() {
  const { sort, search, group_by, mode, filter, columns } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <VStack maxW="100%" maxH="100vh" overflow={'hidden'} flexGrow={1}>
      <IndicatorHeader />
      <Box p={'0rem 1rem'} w={'full'} h={'80%'}>
        <Box p={'3px'} bg={'#F1F7FA'} justifyContent="center" w={'100%'}>
          <Flex bg="#F1F7FA" justifyContent="center">
            <HStack justifyContent="space-between" width="100%" p="1rem 1.5rem" bg="white" wrap="wrap">
              <SearchInput search={search} />
              <Flex gap={4} justifyContent={'flex-end'} flexGrow={1}>
                <Flex gap={4}>
                  <CollecteFilterDrawer filter={filter} />
                  <TableSortMenu sort={sort} navigate={navigate} columnsDef={columnsDefManageYear} />
                  <TableGroupMenu groupBy={group_by} navigate={navigate} columnsDef={columnsDefManageYear} />
                  <TableColumnVisibilityMenu
                    columns={columns}
                    columnsDef={columnsDefManageYear}
                    defaultColumnVisibility={defaultColumnVisibilityManageYear}
                    navigate={navigate}
                  />
                </Flex>
              </Flex>
            </HStack>
          </Flex>
          <ManageCollecteTablePerYear mode={mode} />
        </Box>
      </Box>
    </VStack>
  );
}
